import moment from "moment";
import React from "react";
import StatusChip from "../components/StatusChip";
import Date from "../components/Date";
import ToolTipText from "../components/ToolTipText";
const PLUM_PRO_STATUS_OPTIONS = [
  { label: "Delivered", value: "Delivered" },
  { label: "Pending", value: "pending" },
  { label: "Canceled", value: "canceled" },
];

export const PLUM_PRO_PAYMENTS = [
  {
    label: "Invoice",
    name: "invoice_number",
    defaultChecked: true,
    options: {
      sort: false,
    },
  },
  {
    label: "Amount",
    name: "total",
    defaultChecked: true,
    options: {
      sort: false,
      setCellHeaderProps: () => ({ className: "text-right" }),
      setCellProps: () => ({ className: "text-right" }),
    },
  },
  {
    label: "Date (UTC)",
    name: "date_added",
    defaultChecked: true,
    options: {
      sort: false,
      customBodyRender: (value) => {
        return (
          <span
            style={{
              whiteSpace: "nowrap",
            }}
          >
            <Date value={value} />
          </span>
        );
      },
    },
  },
  {
    label: "Status",
    name: "status",
    options: {
      sort: false,
      customBodyRender: (value, tableMeta, updateValue) => {
        return <StatusChip value={value} />;
      },
      setCellProps: () => ({
        style: {
          textAlign: "center",
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          textAlign: "center",
        },
      }),
    },
  },
  { label: "Action", name: "action" },
];

export const PLUM_PRO_REPORT_KEYS = [
  {
    label: "Order ID",
    name: "order_id",
    defaultChecked: true,
    checked: true,
    search: true,
    sort: false,
    searchKey: "order_id",
    filter: {
      filterType: "inputNumber",
      filters: [
        {
          operation: "IS",
          value: "",
          selected: true,
          key: "order_id",
        },
      ],
    },
  },
  {
    label: "Product Name",
    name: "product_name",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: false,
    filter: {
      filterType: "input",
      filters: [
        {
          operation: "IS",
          value: "",
          selected: true,
          key: "product_name",
        },
        {
          operation: "CONTAINS",
          value: "",
          selected: false,
          key: "product_name",
        },
      ],
    },
    options: {
      sort: false,
      setCellProps: () => ({
        style: { maxWidth: "250px", whiteSpace: "nowrap" },
      }),
      customBodyRender: (value) => {
        return <ToolTipText value={value} />;
      },
    },
  },
  {
    label: "Product ID",
    name: "product_id",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: false,
    filter: {
      filterType: "inputNumber",
      filters: [
        { operation: "IS", value: "", selected: true, key: "product_id" },
      ],
    },
    options: {
      sort: false,
      setCellHeaderProps: () => ({ className: "text-right" }),
      setCellProps: () => ({ className: "text-right" }),
    },
  },
  {
    label: "Recipient Email",
    name: "receiver_email",
    defaultChecked: true,
    checked: true,
    search: true,
    sort: false,
    searchKey: "receiver_email",
    filter: {
      filterType: "input",
      filters: [
        {
          operation: "IS",
          value: "",
          selected: true,
          key: "receiver_email",
        },
      ],
    },
    options: { sort: false },
  },
  {
    label: "Recipient Phone",
    name: "receiver_mobile_number",
    defaultChecked: true,
    checked: true,
    search: true,
    sort: false,
    searchKey: "receiver_phone_number",
    options: { sort: false, display: false },

    filter: {
      filterType: "inputNumber",
      filters: [
        {
          operation: "IS",
          value: "",
          selected: true,
          key: "receiver_mobile_number",
        },
      ],
    },
  },
  {
    label: "Currency",
    name: "currency_code",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: false,
    options: {
      sort: false,
    },
  },
  {
    label: "Denomination",
    name: "denomination",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: false,
    options: { sort: false },
  },
  {
    label: "Sent Date (UTC)",
    name: "date_added",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: true,
    filter: {
      filterType: "date",
      filters: {
        operation: "IS BETWEEN",
        startDate: "",
        endDate: "",
        selected: true,
      },
    },
    options: {
      sort: false,
      customBodyRender: (value) => {
        return (
          <span
            style={{
              whiteSpace: "nowrap",
            }}
          >
            <Date value={value} />
          </span>
        );
      },
    },
  },
  {
    label: "Delivered Date (UTC)",
    name: "delivery_date",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: true,

    filter: {
      filterType: "date",
      filters: {
        operation: "IS BETWEEN",
        startDate: "",
        endDate: "",
        selected: true,
      },
    },
    options: {
      sort: false,
      display: false,
      customBodyRender: (value) => {
        return (
          <span
            style={{
              whiteSpace: "nowrap",
            }}
          >
            <Date value={value} />
          </span>
        );
      },
    },
  },
  {
    label: "Quantity",
    name: "quantity",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: false,
    options: {
      display: false,
      sort: false,
      setCellHeaderProps: () => ({ className: "text-right" }),
      setCellProps: () => ({ className: "text-right" }),
    },
  },
  {
    label: "Delivered Quantity",
    name: "delivered_quantity",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: false,
    options: {
      display: false,
      sort: false,
      setCellHeaderProps: () => ({ className: "text-right" }),
      setCellProps: () => ({ className: "text-right" }),
    },
  },
  {
    label: "Pending Quantity",
    name: "pending_quantity",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: false,
    options: {
      display: false,
      sort: false,
      setCellHeaderProps: () => ({ className: "text-right" }),
      setCellProps: () => ({ className: "text-right" }),
    },
  },
  {
    label: "Canceled Quantity",
    name: "cancelled_quantity",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: false,
    options: {
      display: false,
      sort: false,
      setCellHeaderProps: () => ({ className: "text-right" }),
      setCellProps: () => ({ className: "text-right" }),
    },
  },
  {
    label: "Discount (%)",
    name: "product_discount",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: false,
    options: {
      display: false,
      sort: false,
      setCellHeaderProps: () => ({ className: "text-right" }),
      setCellProps: () => ({ className: "text-right" }),
    },
  },
  {
    label: "Amount Charged",
    name: "amount_charged",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: false,
    options: { sort: false },
  },
  {
    label: "Status",
    name: "delivery_status",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: false,
    filter: {
      filterType: "select",
      filters: {
        value: "",
        options: PLUM_PRO_STATUS_OPTIONS,
        operation: "IS",
      },
    },
    options: {
      sort: false,
      customBodyRender: (value) => {
        return <StatusChip value={value} />;
      },
    },
  },
  {
    label: "PO Number",
    name: "po_number",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: false,
    options: {
      sort: false,
      display: false,
    },

    filter: {
      filterType: "input",
      filters: [
        {
          operation: "IS",
          value: "",
          selected: true,
          key: "user_po_number",
        },
      ],
    },
  },
  {
    label: "Tag",
    name: "tag",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: false,
    options: { sort: false, display: false },

    filter: {
      filterType: "input",
      filters: [
        { operation: "IS", value: "", selected: true, key: "tag" },
        { operation: "CONTAINS", value: "", selected: false, key: "tag" },
      ],
    },
  },
  {
    label: "Email Delivered On (UTC)",
    name: "email_delivered_on",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: false,
    options: { sort: false, display: false },
  },
  {
    label: "SMS Delivered On (UTC)",
    name: "sms_delivered_on",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: false,
    options: { sort: false, display: false },
  },
  {
    name: "action",
    label: "Action",
    defaultChecked: true,
    options: {
      sort: false,
    },
  },
];
